import { GET_COMMENTS, GET_COMMENTS_V2 } from 'src/constants';
import { axios } from 'src/lib';
import {
  CommentDataPayload,
  ICommentsDetailModel,
  ICommentsDetailModelV2
} from '../../../../pricing-simulator/components/comment-box-container/comment-box-container.model';

export default function fetchCommentsForRow(
  commentDataBody: CommentDataPayload,
  scenarioId: number
) {
  return axios
    .post<{ data: ICommentsDetailModel }>(
      `${GET_COMMENTS}${scenarioId}/`,
      commentDataBody
    )
    .then((response) => response.data);
}

export function fetchCommentsForRowV2(
  commentDataBody: CommentDataPayload,
  scenarioId: number,
  sourceId: number
) {
  return axios
    .post<ICommentsDetailModelV2>(
      `${GET_COMMENTS_V2}${sourceId}/${scenarioId}/`,
      commentDataBody
    )
    .then((response) => response.data);
}
